import React, { useEffect } from "react";
import { useState } from "react";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import axios from "axios";
import { MdOutlineFileDownload } from "react-icons/md";
import { Modal } from "react-bootstrap";
import EditRunbook from "./EditRunbook";

const RunBook = () => {
  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const filesPerPage = 10;
  const [showModal, setShowModal] = useState(false);
  const [previewFileName, setpreviewFileName] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const getFiles = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          "https://devwebsocket.drtestdash.com/runbook/files"
        );
        setFileList(response.data.files);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching files:", error);
      }
    };
    getFiles();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Get month (zero-indexed, add 1)
    const day = String(date.getUTCDate()).padStart(2, "0"); // Get day

    let hours = date.getUTCHours(); // Get UTC hours
    const minutes = String(date.getUTCMinutes()).padStart(2, "0"); // Get minutes

    const period = hours >= 12 ? "PM" : "AM"; // Determine AM/PM
    hours = hours % 12 || 12; // Convert 24-hour to 12-hour format

    return `${year}-${month}-${day} ${String(hours).padStart(
      2,
      "0"
    )}.${minutes} ${period}`;
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(
        `https://devwebsocket.drtestdash.com/runbook/file/download/${fileName}`,
        {
          responseType: "blob", // Important for downloading binary data
        }
      );

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(response.data); // Create an object URL from the response blob
      link.download = fileName; // Suggest the file name to save as
      link.click(); // Simulate a click to trigger the download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handlePreview = async (fileName) => {
    try {
      const response = await fetch(
        `https://devwebsocket.drtestdash.com/runbook/preview-excel/${fileName}`
      );
      const data = await response.json();

      setpreviewFileName(fileName);
      setTableData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Sort files by 'modified' field in descending order (most recent first)
  const sortedFileList = [...fileList].sort((a, b) => {
    const dateA = new Date(a.modified);
    const dateB = new Date(b.modified);
    return dateB - dateA; // Descending order
  });

  // Get current files for the page
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  const currentFiles = sortedFileList.slice(indexOfFirstFile, indexOfLastFile);

  // Pagination controls
  const totalPages = Math.ceil(fileList.length / filesPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); 
  };

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader></MainHeader>

        <div className="ps-4 mt-4">
          {isLoading ? (
            <div className="d-flex justify-content-center my-4">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="main-panel">
              <div>
                <div className="w-100">
                  <div className="card rounded-0">
                    <div className="card-body dashboard p-0">
                      <div className="table-responsive">
                        <table className="table table-alter">
                          <thead className="tablebg">
                            <tr>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Modified
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Size (Byte)
                              </th>

                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top text-center border-bottom"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentFiles.length > 0 ? (
                              currentFiles.map((data) => {
                                return (
                                  <tr id={data?.id} key={data?.id}>
                                    <td className="text-dark border-0">
                                      {data?.name}
                                    </td>
                                    <td className="text-dark border-0">
                                      {formatDate(data?.modified)}
                                    </td>
                                    <td className="text-dark border-0">
                                      {data?.size}
                                    </td>
                                    <td className="border-0 text-center d-flex justify-content-center">
                                      <div>
                                        <div
                                          className="btn p-0 text-primary cursor-pointer"
                                          onClick={() =>
                                            handlePreview(data?.name)
                                          }
                                        >
                                          <i className="fa-regular fa-eye"></i>
                                        </div>
                                      </div>
                                      <div
                                        className="btn p-0 ms-3 text-primary cursor-pointer"
                                        onClick={() =>
                                          handleDownload(data?.name)
                                        }
                                      >
                                        <MdOutlineFileDownload size={25} />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan="8"
                                  className="text-center text-dark border-0"
                                >
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!isLoading && (
            <div className=" pb-3 d-flex justify-content-end">
              <div>
                <button
                  className="button-17 me-2"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  className="button-17"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
        <Modal
          show={showModal}
          dialogClassName="modal-90w"
          onHide={() => setShowModal(false)}
          size="lg"
        >
          <Modal.Header closeButton className="tablebg">
            <Modal.Title>
              <h6 className="text-primarydark mb-0">Runbook Preview</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mx-500">
            <EditRunbook
              show={showModal}
              onHide={() => setShowModal(false)}
              datas={tableData}
              fileNames={previewFileName}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default RunBook;
